import { Inject } from '@odinjs/odin';
import { BarcodeAPI, BarcodeData, ButtonAPI, FieldAPI, FormAPI, ToastService } from '@philips-internal/oswald-ui-components';
import { Placement, ToastLevel } from '@philips-internal/oswald-ui-constants';
import Controller, { OnChange, OnClick, OnMount, OnReadSuccess } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent, ReadEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { isFunction } from '@philips-internal/oswald-ui-utils';

import { ApplicationRoute } from '../../../constants/routes';
import BaseController from '../../BaseController';
import InformationBarUtils from '../../commons/header/information-bar-header-utils';
import { BraceletConfirmationAliases, FragmentNames } from '../../../codegen';
import BarcodeService from '../../../services/barcode-service';

@Controller({ component: BraceletConfirmationAliases.GENERAL_LAYOUT, fragment: FragmentNames.BRACELET_CONFIRMATION })
class BraceletConfirmationController extends BaseController {

  @Inject(BraceletConfirmationAliases.FIELD_INPUT_PATIENT_CONFIRMATION)
  private fieldPatientConfirmation!: FieldAPI;

  @Inject(BraceletConfirmationAliases.BUTTON_CONFIRMATION)
  private buttonViewPrescriptions!: ButtonAPI;

  patientConfirmation(): void {
    const { patientId, encounterId } = this.historyService.getCurrentRouteParams();
    const inputPatientConfirmation = this.context.get('inputPatientConfirmation');

    if (encounterId === String(inputPatientConfirmation)) {
      applicationContext.redirect(`${ApplicationRoute.EXAM_COLLECTION}${ApplicationRoute.SEARCH_PATIENT}${ApplicationRoute.EXAM_COLLECT_PATIENT_CONFIRMATION}${ApplicationRoute.EXAM_COLLECT_PRESCRIPTIONS_LIST}`, {
        encounterId,
        patientId,
      })
    }

    const validatorObj = {
      message: MessageService.translate('text.the-beep-bracelet-is-different-from-the-service-previously-selected'),
      name: '',
      valid: false
    }

    const validatorName = 'bracelet-confirmation-validator';
    this.fieldPatientConfirmation.addLocalValidator(validatorName, async () => ([validatorObj]));
    this.fieldPatientConfirmation.validate();
    this.fieldPatientConfirmation.removeLocalValidator(validatorName);
  }

  errorMessageBarcode(): void{
    const errorMenssage = MessageService.translate('text.the-beep-bracelet-is-different-from-the-service-previously-selected');
    const titleMessage = MessageService.translate('text.message-alert-attention');
    ToastService.close('custom-toast');
    ToastService.open({
      dismissible: true,
      id: 'custom-toast',
      level: ToastLevel.ERROR,
      message: errorMenssage,
      placement: Placement.BOTTOM,
      timeout: 5000,
      title: titleMessage,
    });
  }

  validateBarcode(event: ReadEvent<BarcodeData>): void{
    const inputValue = event.item.value;
    const braceletNumber = Number(inputValue);

    if (!braceletNumber) {
      this.errorMessageBarcode();
      return;
    }

    const {preventDefault} = event;
    if (isFunction(preventDefault)) {
      preventDefault();
    }
  }

  @OnMount(BraceletConfirmationAliases.BARCODE_COMPONENT)
  handleMountBarcode(event: MountEvent): void {
    const barcodeApi = event.target as BarcodeAPI
    barcodeApi.setDefaultReadType(BarcodeService.getDefaultMethodOfReadingBarcode())
  }

  @OnReadSuccess(BraceletConfirmationAliases.BARCODE_COMPONENT)
  onReadSucesstBarCode(event: ReadEvent<BarcodeData>): void {
    this.validateBarcode(event);
    const braceletNumber = event.item.value.trim();
    const { encounterId } = this.historyService.getCurrentRouteParams();

    if (encounterId !== braceletNumber) {
      this.errorMessageBarcode();
    }

    this.context.set({
      inputPatientConfirmation: braceletNumber
    })

    this.patientConfirmation();
  }

  @OnMount(BraceletConfirmationAliases.GENERAL_LAYOUT)
  onMount(): void {

    InformationBarUtils.collapsedBar = true;

    const { patientId, encounterId } = this.historyService.getCurrentRouteParams();
    this.context.set({
      encounterId,
      patientId,
    });
  }

  @OnChange(BraceletConfirmationAliases.FIELD_INPUT_PATIENT_CONFIRMATION)
  onBlurPatientConfirmation(): void {
    const inputPatientConfirmation = this.context.get('inputPatientConfirmation');

    if (inputPatientConfirmation) {
      return this.buttonViewPrescriptions.setEnabled(true);
    }

    return this.buttonViewPrescriptions.setEnabled(false);
  }

  @OnChange(BraceletConfirmationAliases.INPUT_PATIENT_CONFIRMATION)
  onChangePatientConfirmation(event: FormAPI): void {
    this.context.set({
      inputPatientConfirmation: event.getValue()
    })
  }

  @OnClick(BraceletConfirmationAliases.BUTTON_CONFIRMATION)
  onClickButtonBraceletConfirmation(): void {
    this.patientConfirmation()
  }

}

export default BraceletConfirmationController;